export const UNISWAP_V3_SUBGRAPH_ENDPOINT = {
  1: "https://api.thegraph.com/subgraphs/name/uniswap/uniswap-v3",
  137: "https://api.thegraph.com/subgraphs/name/messari/uniswap-v3-polygon",
  10: "https://api.thegraph.com/subgraphs/name/ianlapham/optimism-post-regenesis",
  42161: "https://api.thegraph.com/subgraphs/name/ianlapham/arbitrum-minimal",
};
